import { useCallback, useEffect, useState } from "react"
import { Button, ButtonGroup, Card, Col, Form, Row, Spinner } from "react-bootstrap"
import { estilo_last_mile } from "../../lib/global/styles"
import PantallaCargando from "../general/pantalla_cargando"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { cerrarSesion } from "../../redux/actions/session"
import { urlapi } from "../../lib/backend/data"
import { debounce } from "@mui/material"
import { default_proveedores } from "../proveedores_transporte/data"
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa"
import CourrierEmpresaConfig from "./courrier_empresa_config"

const ConfiguracionCourriersEmpresa = ({ propietario }) => {
    const estructura = {
        courriers: default_proveedores.map(e => ({
            nombre: e.titulo,
            slug: e.slug,
            logo: e.logo,
            options: [],
            active: false
        }))
    }

    const [ id, setId ] = useState("")
    const [ estructuraActual, setEstructuraActual ] = useState(estructura)
    const [ loading, setLoading ] = useState(false)
    const [ pendienteGuardar, setPendienteGuardar ] = useState(false)
    const session = useSelector(state => state.miusuario)
    const [ loadingGuardado, setLoadingGuardado ] = useState(false)
    const token = session.tokenSession
    const dispatch = useDispatch()
    const gris = '#e5e5e5'
    const sub_tipo = "courriers-access"

    useEffect(() => {
        obtenerDatos(sub_tipo)
    }, [])

    const obtenerDatos = async (modulo)=>{
        setLoading(true)
        return fetch(`${urlapi}/configuracion/personalizar`,{
            method:'POST',
            body: JSON.stringify({
                tipo: "logistica",
                sub_tipo: modulo,
                detalles: estructura
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`,
                propietario
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res._id){
                setId(res._id)
                setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.courriers = [
                    ...actual?.courriers,
                    ...res.detalles.courriers.filter(
                        obj2 => !actual.courriers.some(obj1 => obj1.slug === obj2.slug)
                    )
                    ]
                    return {...{}, ...actual}
                }
                )
            }
            return setLoading(false)
        })
        .catch(error => {
            return setLoading(false)
        })
    }
    
    const guardarAutomatico = async (payload)=>{
        setLoadingGuardado(true)
        return fetch(`${urlapi}/configuracion/personalizar`,{
            method:'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            }
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
        .catch(error => {
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
    }
    
    const actualizar = useCallback(debounce((data) => guardarAutomatico(data), 1000), []);


    const handleChangeStatus = (e,i_movulo) => {
        setEstructuraActual(prev => {
            let actual = {...prev}
            actual.modulos[i_movulo].options = e
            actualizar({ _id: id, detalles: actual })
            return { ...actual }
        })
    }

    const toggle = (i) => {
        return setEstructuraActual(prev => {
            let actual = {...prev}
            actual.courriers[i].active = !actual.courriers[i].active
            actualizar({ _id: id, detalles: actual })
            return { ...actual }
        })
    }

    const toggleAll = (val) => {
        return setEstructuraActual(prev => {
            let actual = {...prev}
            actual.courriers = actual.courriers.map(modulo => {
                modulo.active = val
                return modulo
            })
            actualizar({ _id: id, detalles: actual })
            return { ...actual }
        })
    }

    const onChangeProvider = (data, i_modulo) => {
        return setEstructuraActual(prev => {
            let actual = {...prev}
            actual.courriers[i_modulo] = { ...actual.courriers[i_modulo], ...data }
            actualizar({ _id: id, detalles: actual })
            return { ...actual }
        })
    }

    if(loading) return <PantallaCargando />

    return <div>
        <Row>
            <Col><p>Actualiza la visualización por módulo y por campos </p></Col>
            <Col className="text-right text-secondary"><p>{pendienteGuardar ? "Pendiente de guardar cambios" : <b className="text-success" style={{ fontWeight: "bold" }}>¡Guardado!</b> } { loadingGuardado ? <Spinner size="sm" animation="border" variant="primary" /> : false }</p></Col>
        </Row>
        <ButtonGroup>
        <Button variant="light" size="sm" className="mb-3" onClick={() => toggleAll(true)}><FaRegCheckSquare /> SELECCIONAR TODO</Button>
        <Button variant="light" size="sm" className="mb-3" onClick={() => toggleAll(false)}><FaRegSquare /> DESELECCIONAR TODO</Button>
        </ButtonGroup>
        <Row>
            {
                estructuraActual.courriers.map((modulo,imodulo) => {
                    return <Col md={3} key={`modulo-${imodulo}`}  className="mb-3">
                        <Card className="p-3 text-center">
                        <CourrierEmpresaConfig item={modulo} titulo={modulo.nombre} component={modulo.logo ? <img src={modulo.logo} style={{ width: "50%", maxHeight: 20, margin: "0 auto" }} /> : <p className="mb-0" style={{ fontWeight: "bold" }}>{modulo.nombre}</p> } onChange={(data) => onChangeProvider(data,imodulo)} />
                        <div className="hover" onClick={() => toggle(imodulo)}>
                        { modulo.active === true ? <FaRegCheckSquare /> : <FaRegSquare /> }
                        </div>
                        </Card>
                    </Col>
                })
            }
        </Row>
        
    </div>
}

export default ConfiguracionCourriersEmpresa